module.exports = __webpack_public_path__ + "static/media/carta_78.21e87e2c.jpg";